import {
  parseData,
  pageInfo,
  formatServerError,
  formatGraphQLError,
  dispatchMutationReq,
  dispatchMutationResp,
  dispatchMutationErr,
} from "@openimis/fe-core";

// reducer.js or wherever your reducer is located
// import { FORM_VALIDATED } from "./actions";
import { FORM_VALIDATED_REQ, FORM_VALIDATED_RESP, FORM_VALIDATED_ERR } from "./constants"; // Ensure these constants are defined

function reducer(
  state = {
    fetchingAccreditationProjects: false,
    fetchedAccreditationProjects: false,
    errorAccreditationProjects: null,
    accreditationProjects: null,
    fetchingQualityAssuranceProjects: false,
    fetchedQualityAssuranceProjects: false,
    errorQualityAssuranceProjects: null,
    qualityAssuranceProjects: null,
    fetchingAccreditation: false,
    fetchedAccreditation: false,
    errorAccreditation: null,
    accreditation: null,
    accreditationDetails: null,
    fetchingAccreditationDetails: false,
    fetchedAccreditationDetails: false,
    errorAccreditationDetails: null,
    submittingMuation: false,
    accreditationForms: null,
    fetchingAccreditationForms: false,
    fetchedAccreditationForms: false,
    errorAccreditationForms: null,
    accreditationDetail: null,
    fetchingAccreditationDetail: false,
    fetchedAccreditationDetail: false,
    errorAccreditationDetail: null,
    forms: null,
    fetchingForms: false,
    fetchedForms: false,
    errorForms: null,
    accreditationDetailsForms: null,
    fetchingAccreditationDetailsForms: false,
    fetchedAccreditationDetailsForms: false,
    errorAccreditationDetailsForms: null,
    fetchingAccreditationDetailsFormData: false,
    fetchedAccreditationDetailsFormData: true,
    accreditationDetailsFormData: null,
    errorAccreditationDetailsFormData: null,
    fetchingQualityAssurance: false,
    fetchedQualityAssurance: false,
    qualityAssurance: null,
    errorQualityAssurance: null,
    fetchingQualityAssuranceDetails: false,
    fetchedQualityAssuranceDetails: false,
    qualityAssuranceDetails: null,
    errorQualityAssuranceDetails: null,
    fetchingQADetail: false,
    fetchedQADetail: false,
    qaDetail: null,
    errorQADetail: null,
    fetchingAllForms: false,
    fetchedAllForms: false,
    allForms: null,
    errorAllForms: null,
    odkUsers: null,
    fetchingODKUsers: false,
    fetchedODKUsers: false,
    errorODKUsers: null,
    fetchingQRCode: false,
    fetchedQRCode: false,
    QRCode: null,
    errorQRCode: null,
    fetchingAccreditationUsers: false,
    fetchedAccreditationUsers: false,
    accreditationUsers: null,
    errorAccreditationUsers: null,
    qaDetailsForms: null,
    fetchingQADetailsForms: false,
    fetchedQADetailsForms: false,
    errorQADetailsForms: null,
    odkUserAssignments: null,
    fetchingODKUserAssignments: false,
    fetchedODKUserAssignments: false,
    errorODKUserAssignments: null,
    // Add new state variables for QA form data
    fetchingQADetailsFormData: false,
    fetchedQADetailsFormData: false,
    qaDetailsFormData: null,
    errorQADetailsFormData: null,
    // Add new onces
    graphql: {},
    quality_assurance: null,
    fetchingApproveDetailFormDataEntry: false,
    errorApproveDetailFormDataEntry: null,
    approveDetailFormDataEntry: null,
    approveSuccess: true,
    approvingForm: true,
    validatedForms: [],
    qualityAssuranceUsers: [],
    validatingForm: false,
    validationError: null,
    loadingAccreditationUsers: false,
    loadingQAUsers: false,
    errorAccreditationUsers: null,
    errorQAUsers: null,
    mutation: {},
    assigningForms: false,
    assignFormsSuccess: false,
    assignFormsError: null,
    odkUserAssignments: [],
    assigningForms: false,
    assignFormsSuccess: false,
    assignFormsError: null,
  },
  action,
) {
  switch (action.type) {
    case FORM_VALIDATED_REQ:
      return {
        ...state,
        validatingForm: true,
        validationError: null,
      };

    case FORM_VALIDATED_RESP:
      return {
        ...state,
        validatingForm: false,
        validationError: null,
        validatedForms: [
          ...(state.validatedForms || []),
          {
            accreditationId: action.meta?.accreditationId || null,
            uuid: action.meta?.detailFormUuid || null,
          },
        ],
      };

    case FORM_VALIDATED_ERR:
      return {
        ...state,
        validatingForm: false,
        validationError: action.error,
      };

    case "FETCH_ODK_USER_ASSIGNMENT_REQ":
      return {
        ...state,
        fetchingODKUserAssignments: true,
        fetchedODKUserAssignments: false,
        odkUserAssignments: null,
        errorODKUserAssignments: null,
      };
    // Fetch ODK User Assignments
    case "ASSIGN_FORMS_TO_ODK_USER_RESP":
      return {
        ...state,
        assigningForms: false,
        assignFormsSuccess: true,
        assignFormsError: null,
      };

    case "UNASSIGN_FORMS_TO_ODK_USER_RESP":
      return {
        ...state,
        assigningForms: false,
        assignFormsSuccess: true,
        assignFormsError: null,
      };

    case "FETCH_ODK_USER_ASSIGNMENT_RESP":
      return {
        ...state,
        fetchingODKUserAssignments: false,
        fetchedODKUserAssignments: true,
        odkUserAssignments: parseData(action.payload.data.odkUserAssignments),
        errorODKUserAssignments: formatGraphQLError(action.payload),
      };
    case "FETCH_ODK_USER_ASSIGNMENT_ERR":
      return {
        ...state,
        fetchingODKUserAssignments: false,
        errorODKUserAssignments: formatServerError(action.payload),
      };
    case "RESET_ASSIGN_FORM_SUCCESS":
      return {
        ...state,
        assignFormsSuccess: false,
      };
    case "ASSIGN_FORMS_TO_ODK_USER_RESP":
      return {
        ...state,
        assigningForms: false,
        assignFormsSuccess: true,
        assignFormsError: null,
      };

    case "ACCREDITATION_MUTATION_REQ":
      return {
        ...state,
        assigningForms: true,
        assignFormsSuccess: false,
        assignFormsError: null,
      };

    case "ACCREDITATION_MUTATION_ERR":
      return {
        ...state,
        assigningForms: false,
        assignFormsSuccess: false,
        assignFormsError: formatGraphQLError(action.payload),
      };

    case "ACCREDITATION_ACCREDITATION_PROJECTS_REQ":
      return {
        ...state,
        fetchingAccreditationProjects: true,
        fetchedAccreditationProjects: false,
        accreditationProjects: null,
        errorAccreditationProjects: null,
      };
    case "FETCH_ACCREDITATION_USERS_REQ":
      return {
        ...state,
        fetchingAccreditationUsers: true,
        fetchedAccreditationUsers: false,
        accreditationUsers: null,
        errorAccreditationUsers: null,
      };

    case "FETCH_ACCREDITATION_USERS_RESP":
      return {
        ...state,
        fetchingAccreditationUsers: false,
        fetchedAccreditationUsers: true,
        accreditationUsers: parseData(action.payload.data.users),
        errorAccreditationUsers: formatGraphQLError(action.payload),
      };

    case "FETCH_ACCREDITATION_USERS_ERR":
      return {
        ...state,
        fetchingAccreditationUsers: false,
        errorAccreditationUsers: formatServerError(action.payload),
      };

    case "ACCREDITATION_ACCREDITATION_PROJECTS_RESP":
      return {
        ...state,
        fetchingAccreditationProjects: false,
        fetchedAccreditationProjects: true,
        accreditationProjects: parseData(action.payload.data.accreditationProjects),
        errorAccreditationProjects: formatGraphQLError(action.payload),
      };
    case "ACCREDITATION_ACCREDITATION_PROJECTS_ERR":
      return {
        ...state,
        fetchingAccreditationProjects: false,
        errorAccreditationProjects: formatServerError(action.payload),
      };

    case "ACCREDITATION_QUALITY_ASSURANCE_PROJECTS_REQ":
      return {
        ...state,
        fetchingQualityAssuranceProjects: true,
        fetchedQualityAssuranceProjects: false,
        qualityAssuranceProjects: null,
        errorQualityAssuranceProjects: null,
      };
    case "ACCREDITATION_QUALITY_ASSURANCE_PROJECTS_RESP":
      return {
        ...state,
        fetchingQualityAssuranceProjects: false,
        fetchedQualityAssuranceProjects: true,
        qualityAssuranceProjects: parseData(action.payload.data.qualityAssurancies),
        errorQualityAssuranceProjects: formatGraphQLError(action.payload),
      };
    case "ACCREDITATION_QUALITY_ASSURANCE_PROJECTS_ERR":
      return {
        ...state,
        fetchingQualityAssuranceProjects: false,
        errorQualityAssuranceProjects: formatServerError(action.payload),
      };
    case "ACCREDITATION_ACCREDITATION_REQ":
      return {
        ...state,
        fetchingAccreditation: true,
        fetchedAccreditation: false,
        accreditation: null,
        errorAccreditation: null,
      };
    case "ACCREDITATION_ACCREDITATION_RESP":
      return {
        ...state,
        fetchingAccreditation: false,
        fetchedAccreditation: true,
        accreditation: parseData(action.payload.data.accreditationProjects),
        errorAccreditation: formatGraphQLError(action.payload),
      };
    case "ACCREDITATION_ACCREDITATION_ERR":
      return {
        ...state,
        fetchingAccreditation: false,
        errorAccreditation: formatServerError(action.payload),
      };

    case "ACCREDITATION_ACCREDITATION_DETAILS_REQ":
      return {
        ...state,
        fetchingAccreditationDetails: true,
        fetchedAccreditationDetails: false,
        accreditationDetails: null,
        errorAccreditationDetails: null,
      };
    case "ACCREDITATION_ACCREDITATION_DETAILS_RESP":
      return {
        ...state,
        fetchingAccreditationDetails: false,
        fetchedAccreditationDetails: true,
        accreditationDetails: parseData(action.payload.data.accreditationDetails),
        errorAccreditationDetails: formatGraphQLError(action.payload),
      };

    case "ACCREDITATION_ACCREDITATION_DETAILS_ERR":
      return {
        ...state,
        fetchingAccreditationDetails: false,
        errorAccreditationDetails: formatServerError(action.payload),
      };

    case "ACCREDITATION_ACCREDITATION_FORMS_REQ":
      return {
        ...state,
        fetchingAccreditationForms: true,
        fetchedAccreditationForms: false,
        accreditationForms: null,
        errorAccreditationForms: null,
      };

    case "ACCREDITATION_ACCREDITATION_FORMS_RESP":
      return {
        ...state,
        fetchingAccreditationForms: false,
        fetchedAccreditationForms: true,
        accreditationForms: parseData(action.payload.data.accreditationForms),
        errorAccreditationForms: formatGraphQLError(action.payload),
      };

    case "ACCREDITATION_ACCREDITATION_FORMS_ERR":
      return {
        ...state,
        fetchingAccreditationForms: false,
        errorAccreditationForms: formatServerError(action.payload),
      };

    case "ACCREDITATION_ACCREDITATION_DETAIL_REQ":
      return {
        ...state,
        fetchingAccreditationDetail: true,
        fetchedAccreditationDetail: false,
        accreditationDetail: null,
        errorAccreditationDetail: null,
      };

    case "ACCREDITATION_ACCREDITATION_DETAIL_RESP":
      return {
        ...state,
        fetchingAccreditationDetail: false,
        fetchedAccreditationDetail: true,
        accreditationDetail: parseData(action.payload.data.accreditationDetails),
        errorAccreditationDetail: formatGraphQLError(action.payload),
      };

    case "ACCREDITATION_ACCREDITATION_DETAIL_ERR":
      return {
        ...state,
        fetchingAccreditationDetail: false,
        errorAccreditationDetail: formatServerError(action.payload),
      };
    case "ACCREDITATION_PROJECT_FORMS_REQ":
      return {
        ...state,
        fetchingForms: true,
        fetchedForms: false,
        forms: null,
        errorForms: null,
      };
    case "ACCREDITATION_PROJECT_FORMS_RESP":
      return {
        ...state,
        fetchingForms: false,
        fetchedForms: true,
        forms: parseData(action.payload.data.odkForms),
        errorForms: formatGraphQLError(action.payload),
      };
    case "ACCREDITATION_PROJECT_FORMS_ERR":
      return {
        ...state,
        fetchingForms: false,
        errorForms: formatServerError(action.payload),
      };

    case "ACCREDITATION_DETAILS_FORMS_REQ":
      return {
        ...state,
        fetchingAccreditationDetailsForms: true,
        fetchedAccreditationDetailsForms: false,
        accreditationDetailsForms: null,
        errorAccreditationDetailsForms: null,
      };

    case "ACCREDITATION_DETAILS_FORMS_RESP":
      return {
        ...state,
        fetchingAccreditationDetailsForms: false,
        fetchedAccreditationDetailsForms: true,
        accreditationDetailsForms: parseData(action.payload.data.accreditationDetailForms),
        errorAccreditationDetailsForms: formatGraphQLError(action.payload),
      };

    case "ACCREDITATION_DETAILS_FORMS_ERR":
      return {
        ...state,
        fetchingAccreditationDetailsForms: false,
        errorAccreditationDetailsForms: formatServerError(action.payload),
      };

    case "ACCREDITATION_DETAILS_FORMDATA_REQ":
      return {
        ...state,
        fetchingAccreditationDetailsFormData: true,
        fetchedAccreditationDetailsFormData: false,
        accreditationDetailsFormData: null,
        errorAccreditationDetailsFormData: null,
      };

    case "ACCREDITATION_DETAILS_FORMDATA_RESP":
      return {
        ...state,
        accreditationDetailsFormData: action.payload?.data?.projectDetailFormData,
        fetchingAccreditationDetailsFormData: false,
        fetchedAccreditationDetailsFormData: true,
      };

    case "ACCREDITATION_DETAILS_FORMDATA_ERR":
      return {
        ...state,
        fetchingAccreditationDetailsFormData: false,
        errorAccreditationDetailsFormData: formatServerError(action.payload),
      };

    // Add new cases for QA Details Form Data
    case "QA_DETAILS_FORMDATA_REQ":
      return {
        ...state,
        fetchingQADetailsFormData: true,
        fetchedQADetailsFormData: false,
        qaDetailsFormData: null,
        errorQADetailsFormData: null,
      };

    case "QA_DETAILS_FORMDATA_RESP":
      return {
        ...state,
        qaDetailsFormData: action.payload?.data?.projectDetailFormData || {},
        fetchingQADetailsFormData: false,
        fetchedQADetailsFormData: true,
      };

    case "QA_DETAILS_FORMDATA_ERR":
      return {
        ...state,
        fetchingQADetailsFormData: false,
        errorQADetailsFormData: formatServerError(action.payload),
      };

    case "QUALITY_ASSURANCE_REQ":
      return {
        ...state,
        fetchingQualityAssurance: true,
        fetchedQualityAssurance: false,
        qualityAssurance: null,
        errorQualityAssurance: null,
      };

    case "QUALITY_ASSURANCE_RESP":
      return {
        ...state,
        fetchingQualityAssurance: false,
        fetchedQualityAssurance: true,
        qualityAssurance: parseData(action.payload.data.qualityAssurancies),
        errorQualityAssurance: formatGraphQLError(action.payload),
      };

    case "QUALITY_ASSURANCE_ERR":
      return {
        ...state,
        fetchingQualityAssurance: false,
        errorQualityAssurance: formatServerError(action.payload),
      };

    case "HF_QUALITY_ASSURANCE_REQ":
      return {
        ...state,
        fetchingQualityAssuranceDetails: true,
        fetchedQualityAssuranceDetails: false,
        qualityAssuranceDetails: null,
        errorQualityAssuranceDetails: null,
      };

    case "HF_QUALITY_ASSURANCE_RESP":
      return {
        ...state,
        fetchingQualityAssuranceDetails: false,
        fetchedQualityAssuranceDetails: true,
        qualityAssuranceDetails: parseData(action.payload.data.qualityAssuranceDetails),
        errorQualityAssuranceDetails: formatGraphQLError(action.payload),
      };

    case "HF_QUALITY_ASSURANCE":
      return {
        ...state,
        fetchingQualityAssuranceDetails: false,
        errorQualityAssuranceDetails: formatServerError(action.payload),
      };

    case "QUALITY_ASSURANCE_DETAIL_REQ":
      return {
        ...state,
        fetchingQADetail: true,
        fetchedQADetail: false,
        qaDetail: null,
        errorQADetail: null,
      };

    case "QUALITY_ASSURANCE_DETAIL_RESP":
      return {
        ...state,
        fetchingQADetail: false,
        fetchedQADetail: true,
        qaDetail: parseData(action.payload.data.qualityAssuranceDetails),
        errorQADetail: formatGraphQLError(action.payload),
      };
    case "QUALITY_ASSURANCE_DETAIL_ERR":
      return {
        ...state,
        fetchingQADetail: false,
        errorQADetail: formatServerError(action.payload),
      };

    case "All_PROJECT_FORMS_REQ":
      return {
        ...state,
        fetchingAllForms: true,
        fetchedAllForms: false,
        allForms: null,
        errorAllForms: null,
      };

    case "ALL_PROJECT_FORMS_RESP":
      return {
        ...state,
        fetchingAllForms: false,
        fetchedAllForms: true,
        allForms: parseData(action.payload.data.odkForms),
        errorAllForms: formatGraphQLError(action.payload),
      };

    case "ALL_PROJECT_FORMS_ERR":
      return {
        ...state,
        fetchingAllForms: false,
        errorAllForms: formatServerError(action.payload),
      };

    case "ODK_USERS_REQ":
      return {
        ...state,
        fetchingODKUsers: true,
        fetchedODKUsers: false,
        odkUsers: null,
        errorODKUsers: null,
      };
    case "ODK_USERS_RESP":
      return {
        ...state,
        fetchingODKUsers: false,
        fetchedODKUsers: true,
        odkUsers: parseData(action.payload.data.odkUsers),
        errorODKUsers: formatGraphQLError(action.payload),
      };
    case "ODK_USERS_ERR":
      return {
        ...state,
        fetchingODKUsers: false,
        errorODKUsers: formatServerError(action.payload),
      };
    case "FETCH_QRCODE_REQ":
      return {
        ...state,
        fetchingQRCode: true,
        fetchedQRCode: false,
        QRCode: null,
        errorQRCode: null,
      };

    case "FETCH_QRCODE_RESP":
      return {
        ...state,
        fetchingQRCode: false,
        fetchedQRCode: true,
        QRCode: action.payload.data.odkUserQrCodeUri,
        errorQRCode: formatGraphQLError(action.payload),
      };

    case "FETCH_QRCODE_ERR":
      return {
        ...state,
        fetchingQRCode: false,
        errorQRCode: formatServerError(action.payload),
      };

    case "QA_DETAILS_FORMS_REQ":
      return {
        ...state,
        fetchingQADetailsForms: true,
        fetchedQADetailsForms: false,
        qaDetailsForms: null,
        errorQADetailsForms: null,
      };
    case "QA_DETAILS_FORMS_RESP":
      return {
        ...state,
        fetchingQADetailsForms: false,
        fetchedQADetailsForms: true,
        qaDetailsForms: parseData(action.payload.data.qualityAssuranceDetailForms),
        errorQADetailsForms: formatGraphQLError(action.payload),
      };
    case "QA_DETAILS_FORMS_ERR":
      return {
        ...state,
        fetchingQADetailsForms: false,
        errorQADetailsForms: formatServerError(action.payload),
      };

    case "APPROVE_DETAIL_FORM_DATA_ENTRY_REQ":
      return {
        ...state,
        approvingForm: true,
        fetchingApproveDetailFormDataEntry: true,
        errorApproveDetailFormDataEntry: null,
        approveSuccess: false,
      };

    case "APPROVE_DETAIL_FORM_DATA_ENTRY_RESP":
      return {
        ...state,
        approvingForm: false,
        fetchingApproveDetailFormDataEntry: false,
        approveDetailFormDataEntry: action.payload.data, // Assuming the response contains the necessary data
        errorApproveDetailFormDataEntry: formatGraphQLError(action.payload),
        approveSuccess: true,
      };

    case "APPROVE_DETAIL_FORM_DATA_ENTRY_ERR":
      return {
        ...state,
        fetchingApproveDetailFormDataEntry: false,
        errorApproveDetailFormDataEntry: formatServerError(action.payload),
        approveSuccess: false,
        approvingForm: false,
      };

    case "ACCREDITATION_FORM_VALIDATED":
      return {
        ...state,
        validatedForms: [...(state.validatedForms || []), action.payload],
      };
    case "QA_FORM_VALIDATED":
      return {
        ...state,
        validatedForms: [...(state.validatedForms || []), action.payload],
      };
    // added today
    case "CHECK_PROJECT_DETAIL_FORM_DATA":
      return {
        ...state,
        graphql: {
          ...state.graphql,
          CHECK_PROJECT_DETAIL_FORM_DATA: {
            data: action.payload?.data,
            error: action.payload?.error,
            loading: action.payload?.loading,
          },
        },
      };

    case "ACCREDITATION_MUTATION_REQ":
      return dispatchMutationReq(state, action);
    case "ACCREDITATION_MUTATION_ERR":
      return dispatchMutationErr(state, action);
    case "ACCREDITATION_CREATE_ACCREDITATION_PROJECTS_RESP":
      return dispatchMutationResp(state, "createAccreditationProject", action);
    case "CREATE_ACCREDITATION_DETAIL_RESP":
      return dispatchMutationResp(state, "createAccreditationDetail", action);
    case "ACCREDITATION_UPLOAD_ODK_FORM_RESP":
      return dispatchMutationResp(state, "uploadOdkForm", action);
    case "DEPLOY_ACCREDITATION_DETAIL_FORM_RESP":
      return dispatchMutationResp(state, "deployOdkForms", action);
    case "INITIATE_ACCREDITATION_DETAIL_RESP":
      return dispatchMutationResp(state, "initiateQualityAssuranceDetail", action);
    case "INITIATE_QA_DETAIL_RESP":
      return dispatchMutationResp(state, "initiateAccreditationDetail", action);
    case "ACCREDITATION_CREATE_QA_PROJECTS_RESP":
      return dispatchMutationResp(state, "createQualityAssuranceProject", action);
    case "APPROVE_OR_DECLINE_ACCREDITATION_DETAIL_RESP":
      return dispatchMutationResp(state, "approveOrDeclineAccreditationDetail", action);
    case "APPROVE_OR_DECLINE_QA_DETAIL_RESP":
      return dispatchMutationResp(state, "approveOrDeclineQualityAssuranceDetail", action);
    case "CREATE_QUALITY_ASSURANCE_DETAIL_RESP":
      return dispatchMutationResp(state, "createQualityAssuranceDetail", action);
    case "CREATE_ODK_USER_RESP":
      return dispatchMutationResp(state, "createOdkUser", action);
    case "ASSIGN_FORMS_TO_ODK_USER_RESP":
      return dispatchMutationResp(state, "assignOdkUser", action);
    case "UNASSIGN_FORMS_TO_ODK_USER_RESP":
      return dispatchMutationResp(state, "UnassignOdkUser", action);
    case "INITIATE_AND_DEPLOY_FORMS":
      return dispatchMutationResp(state, "bulkInitiateAndDeployOdkForms", action);
    case "START_OR_STOP_ACC":
      return dispatchMutationResp(state, "startOrStopAccreditationDetail", action);
    case "START_OR_STOP_QA":
      return dispatchMutationResp(state, "startOrStopQualityAssuranceDetail", action);
    default:
      return state;
  }
}

export default reducer;
